// extracted by mini-css-extract-plugin
module.exports = {"modalFormLabel":"styles_modalFormLabel__1aJx4"};